import AnchorNavigation from './component'
export default AnchorNavigation
